import { Category } from '@repo/types';
import c from 'classnames';
import { Card, Typography } from 'components';
import CategoriesList from './CategoriesList';
import styles from './MetricsNavigation.module.css';

type MetricsNavigationProps = {
  categories: Category[];
  activeId?: string;
};

export default function MetricsNavigation({
  categories,
  activeId,
}: MetricsNavigationProps) {
  return (
    <Card
      cardBodyClassName={styles.container}
      className={c(styles.wrapper, 'hide-on-mobile')}
    >
      <Typography variant='eyebrow' className={styles.title}>
        Jump to
      </Typography>
      <CategoriesList categories={categories} activeId={activeId} />
    </Card>
  );
}
